import React from 'react';

const DebugInfo = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  
  return (
    <div className="min-h-screen bg-slate-50 p-8">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold mb-6 text-slate-900">🔍 Informations de Debug</h1>
        
        <div className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h2 className="font-semibold text-blue-900 mb-2">URL Backend Configurée</h2>
            <code className="block bg-blue-100 p-3 rounded text-sm break-all">
              {backendUrl || 'NON DÉFINIE'}
            </code>
          </div>
          
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <h2 className="font-semibold text-green-900 mb-2">URL Actuelle</h2>
            <code className="block bg-green-100 p-3 rounded text-sm break-all">
              {window.location.href}
            </code>
          </div>
          
          <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
            <h2 className="font-semibold text-purple-900 mb-2">Test de Connexion</h2>
            <button
              onClick={async () => {
                try {
                  const response = await fetch(`${backendUrl}/api/health`);
                  alert(`Status: ${response.status}`);
                } catch (error) {
                  alert(`Erreur: ${error.message}`);
                }
              }}
              className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
            >
              Tester la Connexion API
            </button>
          </div>
          
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
            <h2 className="font-semibold text-orange-900 mb-2">Instructions</h2>
            <ol className="list-decimal list-inside space-y-2 text-sm">
              <li>Vérifiez que l'URL backend est correcte</li>
              <li>Si l'URL est incorrecte, contactez le support</li>
              <li>Essayez CTRL+F5 ou CMD+SHIFT+R pour forcer le rechargement</li>
              <li>Videz le cache du navigateur si nécessaire</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DebugInfo;
